export const REQUEST_ADVISOR_ORG_INFO = 'requestAdvisorOrgInfo';
export const SET_ADVISOR_ORG_INFO = 'setAdvisorOrgInfo';
